import React from 'react'
import { Flex, Heading, Text } from '@theme-ui/components'
import backgroundStylesGradient from '../../helpers/backgroundStylesGradient'

export default function PageHeroV1({
  businessData,
  // configData,
  pageTitle,
  poweredImages,
  locationIndex,
  variantName,
  options,
  isAdditionalPage
}) {
  const { titles, texts, containerStyles, images, backgroundGradient } = options
  const heroTitle = titles ? titles[locationIndex] : pageTitle ? pageTitle : businessData.name
  const imageIndex = !isAdditionalPage ? locationIndex : 0 // additional pages are built differently and have multiple arrays for multilocations
  const variant = variantName ? variantName : 'pageHeroV1'
  const styles = containerStyles ? JSON.parse(containerStyles) : {}

  const backgroundStyles =
    images && images?.length !== 0
      ? backgroundStylesGradient(images?.[imageIndex], backgroundGradient, poweredImages, locationIndex)
      : 'none'

  return (
    <Flex
      variant={`${variant}.container`}
      className="container"
      sx={{
        backgroundImage: backgroundStyles,
        ...styles
      }}
    >
      <Flex variant={`${variant}.content`} className="content">
        <Heading as="h1" className="title">
          {heroTitle}
        </Heading>
        {texts?.[locationIndex] && <Text className="text">{texts[locationIndex]}</Text>}
      </Flex>
    </Flex>
  )
}
